/**
 * J13: notices. Reads the today data once a second, one notice per event, several at once are joined
 * into one toast. Toast = .ls-card; browser Notification only when the setting is on (permission asked then).
 */
import { CROPS, dailyLinesOf, smallDungeonState, type World } from '@nine/shared';
import { settings } from '../settings';
import '../loading/loading.css';
import './notify.setting';
import { $, h } from './dom';

const SHOW_MS = 6000;

export class Notices {
  private readonly box = h('div', { id: 'notices' });
  private t = 0;
  private readonly ripe = new Map<string, boolean>();
  private readonly armed = { boss: true, dance: true };
  private readonly camps = new Map<string, boolean>();
  private budgetEmpty = false;
  private wasOn = false;
  private primed = false;

  constructor(private readonly world: World) {
    Object.assign(this.box.style, { position: 'fixed', top: '64px', left: '50%', transform: 'translateX(-50%)', zIndex: '40', pointerEvents: 'none', display: 'flex', flexDirection: 'column', gap: '6px', alignItems: 'center' });
    $('#hud').append(this.box);
  }

  sync(dt: number): void {
    // permission is asked only on the off -> on change
    const on = settings.notifyBrowser;
    if (on && !this.wasOn && typeof Notification !== 'undefined' && Notification.permission === 'default') void Notification.requestPermission();
    this.wasOn = on;
    if ((this.t -= dt) > 0) return;
    this.t = 1;
    const out: string[] = [];
    const w = this.world;
    const pr = w.progress;
    for (const [id, p] of Object.entries(pr.trades.plots)) {
      const c = CROPS[p.crop];
      if (!c) continue;
      const done = p.grown >= c.grow;
      if (done && this.ripe.get(id) === false) out.push(`${c.name} สุกแล้ว`);
      this.ripe.set(id, done);
    }
    const mins = (key: string): number | null => {
      const l = dailyLinesOf(w).find((x) => x.includes(key));
      const m = l && /อีก (\d+) นาที/.exec(l);
      return m ? Number(m[1]) : null;
    };
    for (const [k, key, text] of [['boss', 'ปีศาจใหญ่', 'บอสโลกจะปรากฏในอีก 10 นาที'], ['dance', 'รำสำนัก', 'รำสำนักจะเริ่มในอีก 10 นาที']] as const) {
      const m = mins(key);
      if (m !== null && m <= 10 && m > 0) {
        if (this.armed[k] && this.primed) out.push(text);
        this.armed[k] = false;
      } else if (m === null || m > 10) this.armed[k] = true;
    }
    for (const c of smallDungeonState(w)) {
      if (this.camps.get(c.id) === true && !c.cleared) out.push(`ค่าย ${c.name} กลับมาแล้ว`);
      this.camps.set(c.id, c.cleared);
    }
    const left = pr.autoBudget?.secs;
    if (left !== undefined) {
      if (left <= 0 && !this.budgetEmpty) out.push('เวลาออโต้วันนี้หมดแล้ว');
      this.budgetEmpty = left <= 0;
    }
    this.primed = true;
    if (out.length) this.show(out);
  }

  private show(lines: string[]): void {
    const card = h('div', { class: 'ls-card' }, ...lines.map((l) => h('div', {}, l)));
    card.style.cssText = 'padding:8px 18px;font-size:14px;text-align:center';
    this.box.append(card);
    setTimeout(() => card.remove(), SHOW_MS);
    if (settings.notifyBrowser && typeof Notification !== 'undefined' && Notification.permission === 'granted') new Notification('Nine Swords', { body: lines.join('\n') });
  }
}
